import React from "react";

import Header from "./components/Header";

export default function App() {
  return (
    <main className="text-gray-400 bg-gray-900">
      <Header />
    </main>
  );
}
